module.exports = __webpack_public_path__ + "img/carousel.bdb8d609.jpeg";